<template>
  <v-app>
    <!-- Banner de instalación (no bloquea la app) -->
    <div v-if="showInstallBanner" class="install-banner">
      <div class="install-banner-content">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="28" height="28" class="install-banner-icon">
          <rect width="512" height="512" rx="100" fill="#075E54"/>
          <g transform="translate(256,256)">
            <path d="M-106,128 C-165,96 -165,-53 -106,-96 C-48,-138 48,-138 106,-96 C165,-53 165,96 106,128 L112,181 L53,128" fill="none" stroke="white" stroke-width="22" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="-53" cy="-11" r="16" fill="white"/>
            <circle cx="0" cy="-11" r="16" fill="white"/>
            <circle cx="53" cy="-11" r="16" fill="white"/>
          </g>
        </svg>
        <span class="install-banner-text">Instala Yapp para una mejor experiencia</span>
        <button v-if="deferredPrompt" class="install-banner-btn" @click="installApp">Instalar</button>
        <button class="install-banner-close" @click="dismissBanner">&times;</button>
      </div>
    </div>

    <router-view />

    <!-- Global snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      :location="snackbar.location"
    >
      {{ snackbar.text }}
      <template #actions>
        <v-btn variant="text" @click="snackbar.show = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useSnackbar } from '@/composables/snackbar'

const { snackbar } = useSnackbar()

const isInstalled = ref(false)
const deferredPrompt = ref(null)
const bannerDismissed = ref(false)

const showInstallBanner = computed(() => {
  return !isInstalled.value && !bannerDismissed.value
})

const checkInstalled = () => {
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true
}

const onBeforeInstallPrompt = (e) => {
  e.preventDefault()
  deferredPrompt.value = e
}

const onAppInstalled = () => {
  deferredPrompt.value = null
  isInstalled.value = true
}

const installApp = async () => {
  if (!deferredPrompt.value) return
  deferredPrompt.value.prompt()
  const { outcome } = await deferredPrompt.value.userChoice
  if (outcome === 'accepted') {
    isInstalled.value = true
  }
  deferredPrompt.value = null
}

const dismissBanner = () => {
  bannerDismissed.value = true
}

onMounted(() => {
  isInstalled.value = checkInstalled()

  window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt)
  window.addEventListener('appinstalled', onAppInstalled)

  window.matchMedia('(display-mode: standalone)').addEventListener('change', (e) => {
    if (e.matches) isInstalled.value = true
  })
})

onBeforeUnmount(() => {
  window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt)
  window.removeEventListener('appinstalled', onAppInstalled)
})
</script>

<style>
/* Reset global para que el fondo sea correcto */
html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100%;
}
</style>

<style scoped>
.install-banner {
  background: #075E54;
  padding: 8px 16px;
  flex-shrink: 0;
  z-index: 1000;
}

.install-banner-content {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 1400px;
  margin: 0 auto;
}

.install-banner-icon {
  flex-shrink: 0;
  border-radius: 6px;
}

.install-banner-text {
  color: white;
  font-size: 13px;
  flex: 1;
}

.install-banner-btn {
  background: #25D366;
  color: white;
  border: none;
  border-radius: 16px;
  padding: 5px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}

.install-banner-btn:hover {
  background: #20bd5a;
}

.install-banner-close {
  background: none;
  border: none;
  color: rgba(255,255,255,0.7);
  font-size: 20px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}

.install-banner-close:hover {
  color: white;
}
</style>
